import { warrantyInfoMessages } from '../../../../utilities/messages';
import Shield from '../../../../assets/svgs/shield.svg';
import Nighttime from '../../../../assets/svgs/nighttime.svg';
import Daytime from '../../../../assets/svgs/daytime.svg';
import CreditCard from '../../../../assets/svgs/credit-card.svg';
import Delivery from '../../../../assets/svgs/delivery.svg';

const {
  warrantyInfoTitle,
  tenYearWarranty,
  tenYearWarrantyAppliesTo,
  oneYearWarranty,
  oneYearWarrantyAppliesTo,
  oneHundredNightTrial,
  oneHundredNightTrialAppliesTo,
  thirtyDayTrial,
  thirtyDayTrialAppliesTo,
  flexibleFinancingOptions,
  flexibleFinancingOptionsSub,
  freeShipping,
  freeShippingSub,
  shieldIconAlt,
  nighttimeIconAlt,
  daytimeIconAlt,
  creditCardIconAlt,
  deliveryIconAlt,
} = warrantyInfoMessages;

const WarrantyInfo = () => (
  <div className="warranty-info-container m-b-xs">
    <div className="warranty-header ff-wallop m-b-xs ta-center">
      <h4 className="rest-easy-h4 c-purple-primary">{warrantyInfoTitle}</h4>
    </div>
    <div className="warranty-info ff-graphik">
      <div className="m-b-xs warranty-item">
        <div className="warranty-icon">
          <img
            className="shield-icon"
            src={Shield}
            alt={shieldIconAlt}
          />
        </div>
        <div className="warranty-item-left">
          <h5 className="ff-wallop c-purple warranty-label">{tenYearWarranty}</h5>
          <p className="warranty-text">{tenYearWarrantyAppliesTo}</p>
        </div>
      </div>
      <div className="m-b-xs warranty-item">
        <div className="warranty-icon">
          <img
            className="shield-icon"
            src={Shield}
            alt={shieldIconAlt}
          />
        </div>
        <div className="warranty-item-left">
          <h5 className="ff-wallop c-purple warranty-label">{oneYearWarranty}</h5>
          <p className="warranty-text">{oneYearWarrantyAppliesTo}</p>
        </div>
      </div>
      <div className="m-b-xs warranty-item">
        <div className="warranty-icon">
          <img
            className="nighttime-icon"
            src={Nighttime}
            alt={nighttimeIconAlt}
          />
        </div>
        <div className="warranty-item-left">
          <h5 className="ff-wallop c-purple warranty-label">{oneHundredNightTrial}</h5>
          <p className="warranty-text">{oneHundredNightTrialAppliesTo}</p>
        </div>
      </div>
      <div className="m-b-xs warranty-item">
        <div className="warranty-icon">
          <img
            className="daytime-icon"
            src={Daytime}
            alt={daytimeIconAlt}
          />
        </div>
        <div className="warranty-item-left">
          <h5 className="ff-wallop c-purple warranty-label">{thirtyDayTrial}</h5>
          <p className="warranty-text">{thirtyDayTrialAppliesTo}</p>
        </div>
      </div>
      <div className="m-b-xs warranty-item">
        <div className="warranty-icon">
          <img
            className="credit-card-icon"
            src={CreditCard}
            alt={creditCardIconAlt}
          />
        </div>
        <div className="warranty-item-left">
          <h5 className="ff-wallop c-purple warranty-label">{flexibleFinancingOptions}</h5>
          <p className="warranty-text">{flexibleFinancingOptionsSub}</p>
        </div>
      </div>
      <div className="warranty-item">
        <div className="warranty-icon">
          <img
            className="delivery-icon"
            src={Delivery}
            alt={deliveryIconAlt}
          />
        </div>
        <div className="warranty-item-left">
          <h5 className="ff-wallop c-purple warranty-label">{freeShipping}</h5>
          <p className="warranty-text">{freeShippingSub}</p>
        </div>
      </div>
    </div>
  </div>
);

export default WarrantyInfo;
